<template>
  <footer class="footer">
    <div class="content has-text-centered">
    <section class="footer-logo">
          <figure>
            <img src="@/assets/images/logo-transparent.png">
          </figure>
          Naturerleben-Hamburg.de
    </section>
    <section class="footer-content">
      <div class="columns is-mobile">
        <div class="column">
            <h1>SEITEN</h1>
            <router-link to="/angebote">Angebote</router-link>
            <br>
            <router-link to="/ueber-uns">Über Uns</router-link> 
            <br>
            <router-link to="/impressum">Impressum</router-link>
            <br>
            <router-link to="/impressum#datenschutzerklärung">Datenschutz</router-link>
        </div>
        <div class="column">
          <h1>ANSCHRIFT</h1>
      
          <p>Loki Schmidt Stiftung</p>
          <p>Steintorweg 8</p>
          <p>20099 Hamburg</p>
        </div>
        <div class="column">
          <h1>KONTAKT</h1>
          <p>
            <a href="tel:+49 (0)40 28 40 99 8-0">Tel: +49 (0)40 28 40 99 8-0</a>
          </p>
          <p>Fax: +49 (0)40 28 40 99 8-13</p>
          <p>
            <a href="mailto:info@loki-schmidt-stiftung.de">info@loki-schmidt-stiftung.de</a>
          </p>
          <!-- <div class="column">
            
            <fa :icon="faFacebook" />
            <fa :icon="faTwitter" />
          </div> -->
        </div>
      </div>
    </section>
     <section class="footer-info">
      <div class="columns is-mobile">
        <div class="column"></div>
        <div class="column">
          <figure class="image is-64x64">
            <img src="@/assets/images/loki-logo.png">
          </figure>
        </div>
        <div class="column"></div>
        <div class="column">
          <figure class="image is-128x128">
          <img src="@/assets/images/logo-bue.png">
          </figure>
        </div>
        <div class="column"></div>
      </div>
    </section>
    </div>
  </footer>
</template>


<style scoped lang="scss">
@import '@/assets/styles/main.scss';

.footer {
  background-color: $primaryDark;
  color: $white;
  font-family: Arial, Helvetica, sans-serif;
  
}

.footer-logo {
  -webkit-filter: brightness(0) invert(1);
  filter: brightness(0) invert(1);
  margin-bottom: 10px;
}

.footer-info {
  margin-top: 10px;
}

.footer-content {
  h1 {
  color: $primaryLight;
  }

  a {color: $white}

}
</style>

<script>
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'

export default {
  computed: {
    faFacebook () {
        return faFacebook
    },
    faTwitter () {
        return faTwitter
    }
  },
}
</script>
